function sanitizeShippingBarHTML(html, selector) {
  if (typeof html !== "string") return "";

  const doc = new DOMParser().parseFromString(html, "text/html");
  let root = selector ? doc.querySelector(selector) : null;

  if (!root && selector) {
    const simpleSelector = selector.split(" ").pop();
    if (simpleSelector && simpleSelector !== selector) {
      root = doc.querySelector(simpleSelector);
    }
  }

  if (!root) return html;

  root.querySelectorAll("shipping-bar").forEach((el) => {
    el.removeAttribute("data-ready");
  });

  return root.innerHTML;
}

const __mm_toInt = (v) => {
  const n = parseInt(String(v ?? "").replace(/[^\d-]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
};

const __mm_num = (x) => {
  const s = String(x == null ? "" : x).trim();
  if (!s) return 0;

  const cleaned = s.replace(/[^\d.,-]/g, "");
  if (!cleaned) return 0;

  const lastDot = cleaned.lastIndexOf(".");
  const lastComma = cleaned.lastIndexOf(",");

  let normalized = cleaned;
  if (lastDot > -1 && lastComma > -1) {
    normalized =
      lastDot > lastComma
        ? cleaned.replace(/,/g, "")
        : cleaned.replace(/\./g, "").replace(/,/g, ".");
  } else if (lastComma > -1) {
    normalized = cleaned.replace(/,/g, ".");
  }

  const n = Number(normalized);
  return Number.isFinite(n) ? n : 0;
};

const __mm_up = (v) => (v ? String(v).trim().toUpperCase() : "");

const __mm_getActiveIso = () =>
  __mm_up(document.body.getAttribute("data-crciso")) ||
  __mm_up(document.body.getAttribute("data-currency")) ||
  __mm_up(window.Shopify && Shopify.currency && Shopify.currency.active) ||
  "USD";

const __mm_getCurrencySymbol = () => {
  const b = document.body;
  const icon = b.getAttribute("data-crcicon");
  if (icon && icon.trim()) return icon.trim();

  const iso = __mm_getActiveIso();
  try {
    const parts = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: iso
    }).formatToParts(0);
    const cur = parts.find((p) => p.type === "currency");
    return cur ? cur.value : "$";
  } catch {
    return "$";
  }
};

const __mm_isZeroDecimal = (iso) => {
  const c = String(iso || "").toUpperCase();
  return c === "KRW" || c === "JPY" || c === "CLP";
};

const __mm_majorToMinor = (major, iso) => {
  const c = (iso ? String(iso) : __mm_getActiveIso()).toUpperCase();
  const d = __mm_isZeroDecimal(c) ? 1 : 100;
  return major > 0 ? Math.round(major * d) : 0;
};

const __mm_formatMoneyMinor = (minor) => {
  const iso = __mm_getActiveIso();
  const sym = __mm_getCurrencySymbol();
  const zero = __mm_isZeroDecimal(iso);
  const digits = zero ? 0 : 2;
  const d = zero ? 1 : 100;

  const major = Number(minor) / d;

  const formatted = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(digits === 0 ? Math.round(major) : major);

  return `${sym}${formatted}`;
};

const __mm_fetchCartTotalMinor = async () => {
  try {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });
    const cart = await res.json();
    return __mm_toInt(cart && cart.total_price);
  } catch {
    return 0;
  }
};

/**
 * ✅ data-freelimit-only
 * - body[data-limit] 또는 body[data-freelimit] 없으면 아무 것도 갱신하지 않음
 * - 49 USD 환율 fallback 없음
 */
window.updateFreeShipping = async function updateFreeShipping(cartTotalMinorOverride) {
  try {
    let cartTotalMinor = __mm_toInt(cartTotalMinorOverride);

    if (!cartTotalMinor) {
      const barsNow = document.querySelectorAll("shipping-bar.shipping-bar");
      let domTotal = 0;
      barsNow.forEach((el) => {
        domTotal = Math.max(domTotal, __mm_toInt(el.getAttribute("data-cart-total")));
      });
      cartTotalMinor = domTotal || (await __mm_fetchCartTotalMinor());
    }

    const iso = __mm_getActiveIso();

    // ✅ 오직 data-limit / data-freelimit만 사용
    const freeLimitMajor = __mm_num(
      document.body.getAttribute("data-limit") ||
        document.body.getAttribute("data-freelimit") ||
        "0"
    );

    // 값 없으면 "순수 추종" 정책상 아무 것도 만지지 않음
    if (!(freeLimitMajor > 0)) return;

    const freeLimitMinor = __mm_majorToMinor(freeLimitMajor, iso);
    if (!freeLimitMinor) return;

    const apply = () => {
      const bars = document.querySelectorAll("shipping-bar.shipping-bar");
      if (!bars.length) return;

      bars.forEach((el) => {
        // ✅ threshold도 freelimit 기반으로만 세팅
        const attrThresholdMinor = __mm_toInt(el.getAttribute("data-shipping-threshold"));
        if (freeLimitMinor !== attrThresholdMinor) {
          el.setAttribute("data-shipping-threshold", String(freeLimitMinor));
        }

        el.setAttribute("data-cart-total", String(cartTotalMinor));

        const pctRaw = (cartTotalMinor / freeLimitMinor) * 100;
        const pct = Math.max(0, Math.min(100, pctRaw));

        const progressCalc = `calc(${pct.toFixed(2)}% + 2px)`;
        el.setAttribute("data-progress", progressCalc);

        const textEl =
          el.querySelector(".progress-bar__text") ||
          el.querySelector("[data-progress-text]");

        const inner =
          el.querySelector(".progress-bar__progress-inner") ||
          el.querySelector("[data-progress-line]");

        if (inner) inner.style.width = `${pct.toFixed(2)}%`;

        if (textEl) {
          const remaining = Math.max(0, freeLimitMinor - cartTotalMinor);
          if (remaining > 0) {
            textEl.textContent = `Spend ${__mm_formatMoneyMinor(
              remaining
            )} more for free shipping`;
          } else {
            textEl.textContent = `You\u2019ve unlocked free shipping!`;
          }
        }
      });

      if (typeof window.__shippingBarRefresh === "function") {
        try {
          window.__shippingBarRefresh();
        } catch {}
      }
    };

    requestAnimationFrame(apply);
  } catch (e) {
    console.error("updateFreeShipping error:", e);
  }
};

// ✅ freelimit 업데이트 이벤트가 오면 다시 계산
document.addEventListener("freelimit:updated", () => {
  if (typeof window.updateFreeShipping === "function") window.updateFreeShipping();
});

// ✅ body의 data-freelimit/data-limit이 바뀔 때만 다시 계산 (setInterval 없음)
(() => {
  if (window.__mmFreeLimitOnlyObserverInstalled) return;
  window.__mmFreeLimitOnlyObserverInstalled = true;

  let t = 0;
  const schedule = () => {
    clearTimeout(t);
    // 짧은 디바운스: 연속 변경(35→57 같은 레이스) 중 최종값 반영
    t = setTimeout(() => {
      try {
        window.updateFreeShipping && window.updateFreeShipping();
      } catch {}
    }, 120);
  };

  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "attributes" && m.target === document.body) {
        if (
          m.attributeName === "data-freelimit" ||
          m.attributeName === "data-limit" ||
          m.attributeName === "data-crciso" ||
          m.attributeName === "data-currency" ||
          m.attributeName === "data-crcicon"
        ) {
          schedule();
          return;
        }
      }
    }
  });

  mo.observe(document.body, {
    attributes: true,
    attributeFilter: [
      "data-freelimit",
      "data-limit",
      "data-crciso",
      "data-currency",
      "data-crcicon"
    ]
  });
})();

const getSectionData = (id, section, selector) => ({ id, section, selector });

const cartDrawer = document.querySelector("cart-drawer");
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById("main-cart-items")?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(
        `#shopify-section-${mainCartId}`,
        mainCartId,
        `#shopify-section-${mainCartId} cart-items`
      ),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [getSectionData("#CartDrawer-Body", "cart-drawer", "#CartDrawer-Body")];
  }
} else {
  const mainCartId = document.getElementById("main-cart-items")?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(
        `#shopify-section-${mainCartId}`,
        mainCartId,
        `#shopify-section-${mainCartId} cart-items`
      ),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter")
    ];
  } else {
    sectionsToRender = [];
  }
}

// 다른 스코프에서 쓸 수 있게 노출
window.sectionsToRender = sectionsToRender;

window.__cartDrawerUserInteracted = window.__cartDrawerUserInteracted || false;
window.addEventListener(
  "click",
  function () {
    window.__cartDrawerUserInteracted = true;
  },
  true
);

/**
 * ✅ 섹션 캐시 + "다음 복원시 싱크 필요" 플래그 세팅
 *  - 이 플래그가 head 스크립트에서 mm-cart-syncing을 미리 붙여 플리커를 막음
 */
const __mm_cacheSections = (sectionsObj) => {
  try {
    sessionStorage.setItem(
      "__mm_cart_sections_cache_v1",
      JSON.stringify({ t: Date.now(), sections: sectionsObj })
    );
  } catch {}
  try {
    sessionStorage.setItem("__mm_cart_need_sync", "1");
  } catch {}
};

const __mm_readCachedSections = (maxAgeMs = 5 * 60 * 1000) => {
  try {
    const raw = sessionStorage.getItem("__mm_cart_sections_cache_v1");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.sections) return null;
    if (Date.now() - (parsed.t || 0) > maxAgeMs) return null;
    return parsed.sections;
  } catch {
    return null;
  }
};

const __mm_applySectionsToDOM = (sectionsObj) => {
  const toRender =
    (typeof sectionsToRender !== "undefined" && sectionsToRender) ||
    window.sectionsToRender ||
    [];
  if (!toRender || !toRender.length) return;

  for (const section of toRender) {
    const elementToReplace =
      document.querySelector(section.selector) || document.querySelector(section.id);
    if (!elementToReplace) continue;

    const sectionHTML = sectionsObj && sectionsObj[section.section];
    if (!sectionHTML) continue;

    elementToReplace.innerHTML = sanitizeShippingBarHTML(sectionHTML, section.selector);
  }

  try {
    updateCartCounters && updateCartCounters();
  } catch {}

  requestAnimationFrame(() => {
    try {
      window.__shippingBarRefresh && window.__shippingBarRefresh();
    } catch {}
    try {
      document.dispatchEvent(new CustomEvent("cart:sections:replaced"));
    } catch {}
    try {
      window.updateFreeShipping && window.updateFreeShipping();
    } catch {}
  });
};

const __mm_fetchLatestSections = async () => {
  const toRender =
    (typeof sectionsToRender !== "undefined" && sectionsToRender) ||
    window.sectionsToRender ||
    [];
  const ids = (toRender || []).map((s) => s.section).filter(Boolean);
  if (!ids.length) return null;

  const url = `/?sections=${encodeURIComponent(ids.join(","))}`;
  const res = await fetch(url, { credentials: "same-origin", cache: "no-store" });
  const data = await res.json();
  return data || null;
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-drawer-items") || this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
      requestAnimationFrame(() => window.updateFreeShipping && window.updateFreeShipping());
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value, 10),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener("change", this.debouncedOnChange.bind(this));

    requestAnimationFrame(() => window.updateFreeShipping && window.updateFreeShipping());
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== "updates[]") return;

    // 빈칸·소수·음수는 서버로 보내지 않는다. 보내면 빈칸은 안내 없이 1이 되고,
    // 소수는 "expected String to be a Integer" 같은 원문 에러가 고객에게 보였다.
    if (!/^\d+$/.test(String(event.target.value).trim())) {
      const line = event.target.dataset.index;
      this.rollbackLine(line);
      this.showLineError(line, "Please enter a whole number.");
      return;
    }

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement && document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add("is-loading");

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.clearLineError(line);

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        // 서버 거절(구매수량 상한 422 등)은 {status, message, description} 로 온다.
        // 예전엔 parsedState.errors 만 봐서 이 응답을 지나쳤고, 입력칸 숫자만 바뀐 채
        // 카트는 그대로라 고객이 "담겼다"고 오해했다. 입력값을 되돌리고 사유를 띄운다.
        if (parsedState.status || parsedState.errors) {
          const previous = this.rollbackLine(line);
          this.showLineError(
            line,
            this.getLimitMessage(line, quantity, previous) ||
              parsedState.description ||
              parsedState.message ||
              parsedState.errors
          );
          return;
        }

        this.getSectionsToRender()?.forEach((section) => {
          const elementToReplace =
            document.querySelector(section.selector) || document.querySelector(section.id);
          if (!elementToReplace) return;

          if (parsedState.errors) return;

          const sectionHTML = parsedState.sections && parsedState.sections[section.section];
          if (!sectionHTML) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        });

        try {
          if (parsedState.sections) __mm_cacheSections(parsedState.sections);
        } catch {}

        updateCartCounters && updateCartCounters();

        // PDP 가 카트 수량을 다시 읽게 알린다. 없으면 드로어에서 줄이거나 지워도
        // PDP 는 "이미 N개"라며 담기를 계속 막았다.
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState });
          } catch (e) {
            console.error(e);
          }
        }

        const sumItems = (items) => {
          if (!Array.isArray(items)) return 0;
          let sum = 0;
          for (const it of items) {
            sum +=
              __mm_toInt(it?.final_line_price) ||
              __mm_toInt(it?.line_price) ||
              __mm_toInt(it?.original_line_price) ||
              0;
          }
          return sum;
        };

        const latestTotalMinor =
          (typeof parsedState.total_price === "number" && parsedState.total_price) ||
          (typeof parsedState.items_subtotal_price === "number" &&
            parsedState.items_subtotal_price) ||
          sumItems(parsedState.items);

        requestAnimationFrame(() => {
          window.__shippingBarRefresh && window.__shippingBarRefresh();
          document.dispatchEvent(new CustomEvent("cart:sections:replaced"));
          window.updateFreeShipping && window.updateFreeShipping(latestTotalMinor);
        });
      })
      .catch(() => {
        // 요청이 서버에 반영됐는데 응답만 잃었을 수 있다. 무조건 되돌리지 말고
        // 서버의 현재 카트로 화면을 다시 그린다. 그것도 실패하면 되돌린다.
        __mm_fetchLatestSections()
          .then((sections) => {
            if (!sections) throw new Error("no sections");
            __mm_applySectionsToDOM(sections);
          })
          .catch(() => this.rollbackLine(line));
      })
      .finally(() => this.classList.remove("is-loading"));
  }

  // 같은 라인이 드로어와 카트 페이지에 동시에 있을 수 있어 이 요소 안에서만 찾는다.
  getLineInputs(line) {
    return this.querySelectorAll(`[name="updates[]"][data-index="${line}"]`);
  }

  getLineErrors(line) {
    return this.querySelectorAll(`[data-line-item-error][data-line="${line}"]`);
  }

  // 렌더 시점 value 속성(defaultValue)이 서버가 확정한 수량이다.
  rollbackLine(line) {
    let previous = null;
    this.getLineInputs(line).forEach((input) => {
      input.value = input.defaultValue;
      previous = input.defaultValue;
    });
    return previous;
  }

  // 이 라인의 상한을 넘긴 요청일 때만 우리 문구로 바꾼다. 서버 문구는 "reduce the
  // quantity to continue"라 이미 되돌린 뒤에 읽으면 맞지 않는다. 다른 라인 때문에
  // 거절된 경우는 서버 문구를 그대로 둔다.
  getLimitMessage(line, requested, previous) {
    const el = this.querySelector(`[data-line-item-error][data-line="${line}"]`);
    const limit = el ? parseInt(el.dataset.purchaseLimit, 10) : NaN;
    if (Number.isNaN(limit) || parseInt(requested, 10) <= limit) return null;
    return `This item is limited to ${limit} per order. Your cart still has ${previous}.`;
  }

  showLineError(line, message) {
    if (!message) return;
    const text = typeof message === "string" ? message : String(message);
    this.getLineErrors(line).forEach((el) => {
      el.textContent = text;
    });
  }

  clearLineError(line) {
    this.getLineErrors(line).forEach((el) => {
      el.textContent = "";
    });
  }

  getSectionInnerHTML(html, selector) {
    return sanitizeShippingBarHTML(html, selector);
  }
}
customElements.define("cart-items", CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.close();
    });

    this.setCartLink();

    if (window.Shopify && Shopify.designMode) {
      this.parentElement.addEventListener("shopify:section:select", () => this.open());
      this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
    }
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    }
  }

  open(opener) {
    const inDesign = window.Shopify && Shopify.designMode;
    if (!opener && !window.__cartDrawerUserInteracted && !inDesign) return;

    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector("body").style.overflow = "hidden";

    this.addEventListener(
      "transitionend",
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    requestAnimationFrame(() => window.updateFreeShipping && window.updateFreeShipping());
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector("body").style.overflow = "auto";
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;

      const sectionHTML = response.sections && response.sections[section.section];
      if (!sectionHTML) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      updateCartCounters && updateCartCounters();
    });

    try {
      if (response.sections) __mm_cacheSections(response.sections);
    } catch {}

    requestAnimationFrame(() => {
      window.__shippingBarRefresh && window.__shippingBarRefresh();
      document.dispatchEvent(new CustomEvent("cart:sections:replaced"));
      window.updateFreeShipping && window.updateFreeShipping();
    });

    if (!open) return;

    const inDesign = window.Shopify && Shopify.designMode;
    if (!window.__cartDrawerUserInteracted && !inDesign) return;

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return sanitizeShippingBarHTML(html, selector);
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);


(() => {
  if (window.__mmCartBfcacheFixInstalled) return;
  window.__mmCartBfcacheFixInstalled = true;

  // ✅ 캐시 가드(River 10/27): 캐시는 테마 경로로만 갱신돼 다른 탭·앱·API로 카트가 바뀌면 스테일
  //    (예: 실제 2개인데 "빈 장바구니")이 된다. 아래면 캐시를 건너뛰고 최신 섹션만 반영한다.
  //    ① 드로어가 열려 있음(보고 있는 화면을 옛 내용으로 덮지 않기)
  //    ② 캐시의 상품 수(.cart-drawer__title-counter)가 실제 카트(/cart.js)와 다름 / 읽을 수 없음
  //    ③ 일반 로드: 서버가 방금 그린 화면이 이미 현재 카트라 캐시는 이득 없이 한 번 더 덮을 뿐 → 뒤로/앞으로(BFCache·popstate)만
  let __mm_latestApplied = false;

  const __mm_cachedItemCount = (sections) => {
    try {
      const html = sections && sections["cart-drawer"];
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, "text/html").querySelector(".cart-drawer__title-counter");
      const n = el ? parseInt(el.textContent.trim(), 10) : NaN;
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  };

  const applyCachedSectionsFast = async () => {
    const cached = __mm_readCachedSections();
    if (!cached) return false;
    if (document.querySelector("cart-drawer.is-visible")) return false;
    const cachedCount = __mm_cachedItemCount(cached);
    if (cachedCount === null) return false;
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      const cart = await (await fetch(root + "cart.js", { credentials: "same-origin", cache: "no-store" })).json();
      if (cart.item_count !== cachedCount) return false;
    } catch {
      return false;
    }
    if (__mm_latestApplied || document.querySelector("cart-drawer.is-visible")) return false;  // 최신이 먼저 왔거나 그새 열림
    __mm_applySectionsToDOM(cached);
    return true;
  };

  const refreshSections = async () => {
    const latest = await __mm_fetchLatestSections();
    if (!latest) return false;
    __mm_latestApplied = true;
    __mm_applySectionsToDOM(latest);
    __mm_cacheSections(latest);
    return true;
  };

  const run = async (useCache) => {
    // 혹시 head에서 못 붙인 경우도 커버
    try {
      if (sessionStorage.getItem("__mm_cart_need_sync") === "1") {
        document.documentElement.classList.add("mm-cart-syncing");
      }
    } catch {}

    // 캐시가 실제 카트와 맞을 때만 먼저 덮고(체감 개선) -> 서버로 확정(정합성). 둘은 병렬, 최신이 이기게.
    __mm_latestApplied = false;
    if (useCache) applyCachedSectionsFast();
    await refreshSections();

    // 싱크 완료: 플래그 제거 + 가림 해제
    try {
      sessionStorage.removeItem("__mm_cart_need_sync");
    } catch {}

    requestAnimationFrame(() => {
      document.documentElement.classList.remove("mm-cart-syncing");
    });
  };

  window.addEventListener("pageshow", (e) => {
    // BFCache 복원 포함 — 캐시는 복원(persisted)일 때만
    run(!!(e && e.persisted));
  });

  window.addEventListener("popstate", () => {
    run(true);
  });
})();


// 드로우 열리기 전 로딩 스피너 함수
(function () {
  if (window.__mmCartOpenDelaySpinnerInstalled) return;
  window.__mmCartOpenDelaySpinnerInstalled = true;

  var DELAY_MS = 500;

  function showOnDrawer(drawer) {
    try {
      drawer.classList.add("is-loading");
    } catch (e) {}
  }

  function hideOnDrawer(drawer) {
    try {
      drawer.classList.remove("is-loading");
    } catch (e) {}
  }

  function patchDrawer(drawer) {
    if (!drawer || drawer.__mmOpenDelaySpinnerPatched) return;
    drawer.__mmOpenDelaySpinnerPatched = true;

    var origOpen = drawer.open;
    var origClose = drawer.close;

    drawer.__mmOpenDelayTimer = null;
    drawer.__mmOpenDelayInFlight = false;

    if (typeof origOpen === "function") {
      drawer.open = function () {
        var self = this;

        if (self.__mmOpenDelayInFlight) return;
        self.__mmOpenDelayInFlight = true;

        var args = arguments;

        showOnDrawer(self);

        clearTimeout(self.__mmOpenDelayTimer);
        self.__mmOpenDelayTimer = setTimeout(function () {
          self.__mmOpenDelayInFlight = false;

          hideOnDrawer(self);
          origOpen.apply(self, args);
        }, DELAY_MS);
      };
    }

    if (typeof origClose === "function") {
      drawer.close = function () {
        var self = this;
        clearTimeout(self.__mmOpenDelayTimer);
        self.__mmOpenDelayInFlight = false;

        hideOnDrawer(self);

        return origClose.apply(this, arguments);
      };
    }
  }

  function init() {
    var drawer = document.querySelector("cart-drawer");
    if (drawer) patchDrawer(drawer);

    var mo = new MutationObserver(function () {
      var d = document.querySelector("cart-drawer");
      if (d) patchDrawer(d);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();